module.exports = __webpack_public_path__ + "static/img/df.3a1978a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/df.png
// module id = 6
// module chunks = 0